import { FileHelpBox } from 'components/v2/help-boxes';
import { Button } from 'primereact/button';
import React, { useId } from 'react';
import { FileModel } from 'services/EpdClient';
import FileService from 'services/FileService';
import styled from 'styled-components';
import Tooltip from 'components/controls/Tooltip';

export const FileViewRow: React.FunctionComponent<{
  file?: FileModel;
  style?: React.CSSProperties;
  className?: string;
}> = ({ file, style, className }) => {
  const downloadButtonId = useId();

  const fileUrl = FileService.getImageUrl(file?.id || '');

  return (
    <FileHelpBox
      className={className}
      style={{
        overflow: 'hidden',
        ...style,
      }}
    >
      <Text>
        {file?.name ?? '\u00A0'}
        <Tooltip position="title">{file?.name}</Tooltip>
      </Text>
      <div style={{ display: 'flex', alignItems: 'center', maxHeight: '1rem' }}>
        {file?.id && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Button id={downloadButtonId} text icon="pi pi-download" onClick={() => window.open(fileUrl, '_blank')} />{' '}
            <Tooltip targetId={downloadButtonId} position="title">
              Download file
            </Tooltip>
          </div>
        )}
      </div>
    </FileHelpBox>
  );
};

const Text = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: none;
  word-break: keep-all;
  white-space: nowrap;
`;

export default FileViewRow;
